import React, { useEffect, useState, useContext } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Col,
  Form,
} from "reactstrap";
import Select from "react-select";
import {
  resourcesRoutes,
  resourcesOperators,
  resourcesUnits,
  resourcesImprevistos,
  imprevistosSelects,
} from "../../helpers/backend_helper";
import { getStorageCompany } from "../../helpers/api_helper";
import { Alert } from "../../helpers/alerts/alertHelper";
import Validate from "./Validate";
import { useFormik } from "formik";
import * as Yup from "yup";
import NibbleInput from "../../components/Fields/NibbleInput";

const AddUpdModal = ({
  modal,
  setModal,
  items,
  setItems,
  setItem,
  item,
  authUser,
  operators,
  units,
}) => {
  const company = getStorageCompany();
  const [filters, setFilters] = useState({
    page: 1,
    perPage: 20,
    search: "",
    orderBy: "id",
    order: "asc",
    route_id: null,
    select: true,
  });
  let params = { params: filters };
  const [routes, setRoutes] = useState([]);
  const [errors, setErrors] = useState([]);
  const [selects, setSelects] = useState({
    castigos: [],
    routes: [],
    operators: operators,
    units: units,
    tipos: [],
  });
  const [loading, setLoading] = useState(false);
  const handleClose = () => {
    setModal({ ...modal, show: false, update: false });
    setItem({
      ...item,
      fecha: "",
      descripcion: "",
      tipo_id: null,
      tipo: null,
      castigo_id: null,
      castigo: null,
      unidad_id: null,
      unidad: null,
      operador_id: null,
      operador: null,
      time: "",
    });
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: { ...item },
    validationSchema: Yup.object({
      unit_id: Yup.string().nullable().required("Requerido"),
      fecha: Yup.string().nullable().required("Requerido"),
      time: Yup.string().nullable().required("Requerido"),
      tipo_id: Yup.string().nullable().required("Requerido"),
      operator_id: Yup.number().nullable().required("Requerido"),
      castigo_id: Yup.number().nullable().required("Requerido"),
      descripcion: Yup.string().nullable().required("Requerido"),
    }),
    onSubmit: async (values) => {
      await save(values);
    },
  });

  const save = async (data) => {
    setLoading(true);
    const response = modal.update
      ? await resourcesImprevistos("put", data, data.id)
      : await resourcesImprevistos("post", data);
    responseAction(response);
  };

  const responseAction = (response) => {
    if (response.status) {
      const newItem = response.imprevisto;
      let array = [];
      if (modal.update) {
        array = items.map((item) => (item.id !== newItem.id ? item : newItem));
      } else {
        array = [...items, newItem];
        array.sort((a, b) => {
          return a.id - b.id;
        });
      }
      setItems(array);
      handleClose();
      setLoading(false);
    } else {
      setLoading(false);
      setErrors(response.response.data.errors);
    }
  };

  useEffect(() => {
    if (authUser.profile_id != 3) {
      resourcesRoutes("get", {}).then((response) => {
        setRoutes(response.data);
      });
    }
  }, []);

  useEffect(() => {
    getSelects();
  }, [filters]);

  useEffect(() => {
    if (validation.values.unit_id && selects.operators) {
      let oper = selects.operators.filter(
        (e) => e.unit_id == validation.values.unit_id
      );
      console.log("oper", oper);
      if (oper.length > 0) validation.setFieldValue("operator_id", oper[0].id);
    }
  }, [validation.values.unit_id]);

  const getSelects = () => {
    if (!filters.route_id) {
      resourcesUnits("get", params).then((units) => {
        imprevistosSelects().then((response) => {
          setSelects({
            ...selects,
            units: units.data,
            castigos: response.castigos,
            tipos: response.tipos,
          });
        });
      });
    } else {
      console.log("oks");
      // resourcesOperators('get',params).then(response => {
      // 	setSelects({...selects,operators:response.data})
      // })
    }
  };

  return (
    <div>
      <Modal isOpen={modal.show}>
        <ModalHeader className="bg-primary">
          {modal.update ? "Editar" : "Añadir"} Imprevisto
        </ModalHeader>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <ModalBody>
            <div className="row">
              <Col className="d-none" md={12}>{JSON.stringify(validation.values)}</Col>

              <NibbleInput
                md={6}
                label="Unidad / Camión:"
                fieldName="unit_id"
                fieldType="select"
                selectItems={selects.units}
                validation={validation}
                selectOptionLabel={(option) => `${option.number}`}
              />

              <NibbleInput
                md={6}
                label="Operador:"
                fieldName="operator_id"
                fieldType="select"
                selectItems={selects.operators}
                validation={validation}
                selectOptionLabel={(option) => `${option.full_name}`}
              />

              <NibbleInput
                md={6}
                label="Tipo:"
                fieldName="tipo_id"
                fieldType="select"
                selectItems={selects.tipos}
                validation={validation}
                selectOptionLabel={(option) => `${option.name}`}
              />

              <NibbleInput
                md={6}
                label="Castigo:"
                fieldName="castigo_id"
                fieldType="select"
                selectItems={selects.castigos}
                validation={validation}
                selectOptionLabel={(option) => `${option.name}`}
              />

              <NibbleInput
                md={6}
                label="Fecha:"
                fieldName="fecha"
                fieldType="date"
                validation={validation}
              />

              <NibbleInput
                md={6}
                label="Hora:"
                fieldName="time"
                fieldType="time"
                validation={validation}
              />

              <NibbleInput
                md={12}
                label="Descripción:"
                fieldName="descripcion"
                fieldType="textarea"
                validation={validation}
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" type="submit" disabled={loading}>
              {loading && <Spinner size="sm"></Spinner>}{" "}
              <i className="fas fa-save"></i> Guardar
            </Button>{" "}
            <Button color="secondary" onClick={handleClose}>
              {" "}
              <i className="fas fa-times"></i> Cancelar
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default AddUpdModal;
